import { ENV } from './environment'
import { envConstants } from './constants'

// let apiBase = 'http://localhost:8080/'
let apiBase = 'https://api.anomaleet.dev/v2/'
let exportBase = 'https://cdn.anomaleet.com/export/'

if (!ENV.production) {
  apiBase = 'http://localhost:8080/'
  // exportBase = 'http://127.0.0.1/export/'
}

export const URIS = {
  login: apiBase + 'login',
  search: apiBase + 'anomalies',
  anomaly: apiBase + 'anomaly',
  profile: apiBase + 'profile',
  detections: apiBase + 'detections',
  attributes: apiBase + 'attributes',
  lots: apiBase + 'lots',
  export: apiBase + 'export',
  massive: apiBase + 'massive',
  images: apiBase + 'images',
  photos: apiBase + 'photos',
  file: exportBase,
  assets: apiBase + 'assets/',
  clusters: apiBase + 'assets/clusters/',
  inspections: apiBase + 'inspections',
  restores: apiBase + 'restores',
  status: apiBase + 'status',
  cdn: {
    photos: 'https://cdn.anomaleet.com/photos'
  },
  mission: 'https://mission.anomaleet.com/?points=',
  axiosHeaders: {
    'Content-Type': 'application/json'
  }
}

export function loadHeaders() {
  return {
    'X-Bearer': window.localStorage.getItem(envConstants.ls.bearer),
    'X-Time': window.localStorage.getItem(envConstants.ls.time),
    'X-Email': window.localStorage.getItem(envConstants.ls.email),
    'Content-Type': 'application/json'
  }
}
